module.exports = __webpack_public_path__ + "static/media/logo-admin.bf357345.png";